import { render, staticRenderFns } from "./ProductPurchase.vue?vue&type=template&id=97ec1cac&"
import script from "./ProductPurchase.vue?vue&type=script&lang=js&"
export * from "./ProductPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports